import styled, { css } from 'styled-components';
import { Chip } from '@/common/styles/shared.styles';
import { THEME } from '@/common/styles/theme';

export const LoungeTags = styled.section`
	z-index: 3;
	padding: 12px min(5vw, 64px) 10px;
	border-bottom: 1px solid rgba(246, 142, 255, 0.13);
	background: rgba(5, 5, 7, 0.82);
	backdrop-filter: blur(16px);
	min-width: 0;
	overflow-x: clip;

	@media (max-width: ${THEME.mobileBreakpoint}) {
		padding: 12px ${THEME.mobileGutter} 10px;
	}
`;

export const CategoryScrollWrap = styled.div`
	position: relative;
	min-width: 0;
	width: 100%;
	overflow-x: clip;

	&::before,
	&::after {
		content: '';
		position: absolute;
		top: 0;
		bottom: 4px;
		z-index: 1;
		width: 42px;
		pointer-events: none;
		opacity: 0;
		transition: opacity 0.16s ease;
	}

	&::before {
		left: 0;
		background: linear-gradient(90deg, rgba(5, 5, 7, 0.86), transparent);
	}

	&::after {
		right: 0;
		background: linear-gradient(270deg, rgba(5, 5, 7, 0.86), transparent);
	}

	${(props) =>
		props.$showPrevFade &&
		css`
			&::before {
				opacity: 1;
			}
		`}

	${(props) =>
		props.$showNextFade &&
		css`
			&::after {
				opacity: 1;
			}
		`}
`;

export const CategoryStrip = styled.div`
	display: flex;
	flex-wrap: nowrap;
	gap: 10px;
	overflow-x: auto;
	padding: 2px 34px 6px 2px;
	scrollbar-width: none;
	scroll-behavior: smooth;

	&::-webkit-scrollbar {
		display: none;
	}

	${Chip} {
		flex: 0 0 auto;
	}

	@media (max-width: ${THEME.mobileBreakpoint}) {
		gap: 8px;
		padding: 4px 2px 8px 2px;
	}
`;

export const CategoryScrollButton = styled.button`
	position: absolute;
	top: 2px;
	z-index: 2;
	width: 31px;
	height: 32px;
	display: grid;
	place-items: center;
	border: 1px solid rgba(255, 180, 236, 0.16);
	border-radius: 999px;
	padding: 0;
	color: rgba(255, 240, 252, 0.9);
	background:
		linear-gradient(135deg, rgba(255, 77, 242, 0.15), rgba(255, 180, 107, 0.1)),
		rgba(18, 12, 22, 0.94);
	box-shadow: 0 0 16px rgba(255, 77, 242, 0.13);
	opacity: 0;
	pointer-events: none;
	transition:
		opacity 0.16s ease,
		transform 0.16s ease,
		border-color 0.16s ease;

	${(props) =>
		props.$visible &&
		css`
			opacity: 1;
			pointer-events: auto;
		`}

	&:hover,
	&:focus-visible {
		border-color: rgba(255, 119, 244, 0.36);
		transform: translateY(-1px);
	}

	svg {
		width: 17px;
		height: 17px;
		fill: none;
		stroke: currentColor;
		stroke-width: 2.2;
		stroke-linecap: round;
		stroke-linejoin: round;
	}

	&:disabled {
		opacity: 0;
		pointer-events: none;
	}
`;

export const CategoryScrollPrev = styled(CategoryScrollButton)`
	left: 0;
`;

export const CategoryScrollNext = styled(CategoryScrollButton)`
	right: 0;
`;
